import { api } from "@/shared/libs/axiosClient";
import type { DataForwarderRetryRow, DataForwarderRetryResultSummary } from "../types/recover-types";

interface DataForwarderRetryResponse {
  rows: DataForwarderRetryRow[];
}

/**
 * 에러 상태인 data forwarder 엔트리 조회
 */
export async function fetchDataForwarderRetryEntries(): Promise<DataForwarderRetryRow[]> {
  const response = await api.get<DataForwarderRetryResponse>("/data-forwarder-retry/entries");
  return response.rows;
}

/**
 * 선택한 trans_id들을 Kafka에서 찾아 RabbitMQ로 재전송
 */
export async function resendDataForwarderMessages(transIds: string[]): Promise<DataForwarderRetryResultSummary> {
  return api.post<DataForwarderRetryResultSummary>("/data-forwarder-retry/resend", {
    trans_ids: transIds,
  });
}

/**
 * 수동으로 입력한 JSON을 RabbitMQ로 전송
 */
export async function sendManualJson(jsonText: string): Promise<DataForwarderRetryResultSummary> {
  return api.post<DataForwarderRetryResultSummary>("/data-forwarder-retry/manual-send", {
    jsonText,
  });
}
